<template>
  <div>
    <div class="orders">

      <van-tabs v-model="active" @click="getOrders">
        <van-tab v-for="(type, index) in typeList" :key="index" :id="type.id" :title="type.name" :to="{ path: 'orders', query: { status: type.id }}" >

          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="orders-li" v-for="(item, k) in list" :key="k">
              <div class="o-li-title">
                <span class="o-li-title-l">{{ item.order_no }}</span>
                <!-- <span class="o-li-title-r">{{ item.status_name }}</span> -->
              </div>
              <div class="o-main">
                <div class="img">
                  <img :src="item.goods.image[0].file.full_url" />
                </div>
                <div class="info">
                  <h3>{{ item.goods_name }}</h3>
                  <div class="price">
                    <!-- <span v-if="item.type != 2">￥{{ item.price }}</span> -->
                    <span class="right sp2">x{{ item.purchases }}</span>
                  </div>
                  <!-- <div class="pay-price">
                    <span class="p-sp-2">实付：￥{{ item.pay_price }}</span>
                  </div> -->
                </div>
              </div>
              <div class="o-bottom">
                <p>昵称：{{ item.member.nickname }}</p>
                <p>姓名：{{ item.member.name }}（ID：{{ item.member.id }}）</p>
                <!--
                <p>姓名：{{ item.details_address.name }}，手机号：{{ item.details_address.tel }}</p>
                <p>地址：{{ item.details_address.province }}{{ item.details_address.city }}{{ item.details_address.county }}{{ item.details_address.detail }}</p>
              -->
                <span class="delivery-title">{{ item.is_delivery == 2 ? '发货完成':'发货中' }}</span>
                <span v-if="item.status == 2" class="o-wl" @click="addEdit(item.id)">去发货</span>
                <!--
                <span v-if="item.status == 0" class="o-wl" @click="cancel(item.id)">取消</span>
                <span v-if="item.status == 4" class="o-wl" @click="receipt(item.id)">确认收货</span>
                <router-link :to="{ name: 'ordersShow', query: { id: item.id }}">
                  <span class="o-wl">查看详情</span>
                </router-link>
                -->
              </div>
            </div>

          </van-list>
        </van-tab>
      </van-tabs>

    </div>

    <van-dialog v-model="show" :title="dialogTitle" show-cancel-button :before-close="beforeClose">
      <van-field
        readonly
        clickable
        name="picker"
        :value="info.expressage_name"
        label="选择物流"
        placeholder="请选择物流公司"
        @click="showPicker = true"
      />
      <van-field
        v-model="info.expressage_no"
        name="物流单号"
        label="物流单号"
        placeholder="请输入物流单号"
        :rules="[{ required: true, message: '请填写物流单号' }]"
      />
    </van-dialog>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>

    <Floating toUrl="/users/index" />
    <wxNoShare />
  </div>
</template>

<script>
  import { Tab, Tabs, List, CountDown, Dialog,Form, RadioGroup, Radio, Cell, CellGroup, Picker, Popup } from 'vant';

  export default {
    components: {
      [List.name]: List,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [CountDown.name]: CountDown,
      [Dialog.Component.name]: Dialog.Component,
      [Picker.name]: Picker,
      [Popup.name]: Popup,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      Form
    },
    name: 'orders',
    data() {
      return {
        page: 1,
        active: 2,
        typeList: [],
        list: [],
        listLength: 0,
        loading: false,
        finished: false,
        total: 0,
        title: '已付款',
        members_grade_id: localStorage.getItem('grade_id'),
        show: false,
        showPicker: false,
        dialogTitle: '订单发货',
        info: {
          id: 0,
          expressage_name: '',
          expressage_no: '',
        },
        columns: ['中国工商银行', '中国农业银行', '中国建设银行', '中国邮政储蓄银行', '中国人民银行', '招商银行'],
      };
    },
    created() {
      let title = this.$route.query.title
      this.title = title
      switch (title) {
        case '未付款':
          this.active = 1
          break
        case '已付款':
          this.active = 2
          break
        case '已发货':
          this.active = 3
          break
        default:
      }
      this.getOrders()
    },
    methods: {
      onLoad() {
        /*
        this.$api.get('orders', {page: this.page, title: this.title}, r=>{
          this.typeList = r.data.type_list
          this.list = r.data.list.data
          this.listLength += r.data.list.data.length
          this.page += 1
          this.total = r.data.list.total

          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (this.listLength >= this.total) {
            this.finished = true;
          }
        })
        */
      },
      getOrders(name, title) {
        if(typeof title !== 'undefined'){
          this.title = title
        }
        this.$api.get('manage/orders', {page: this.page, title: this.title}, r=>{
          this.typeList = r.data.type_list
          this.list = r.data.list.data
          this.columns = r.data.expressages
          this.listLength += r.data.list.data.length
          //this.page += 1
          this.total = r.data.list.total

          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (this.listLength >= this.total) {
            this.finished = true;
          }
        })
      },
      cancel(id) {
        let self = this
        Dialog.confirm({
          message: '您确定要取消订单吗？',
        })
          .then(() => {
            this.$api.post('orders/cancel', {id: id}, r=>{
              if(r.success === 1){
                this.$toast({message: '取消成功',onOpened:function(){
                  self.getOrders(self.active, self.title)
                  //location.reload()
                }})
              }
            })
          })
          .catch(() => {
            // on cancel
          });
      },
      receipt(id) {
        let self = this
        this.$api.post('orders/receipt', {id: id}, r=>{
          if(r.success === 1){
            this.$toast({message: '确认收货成功',onOpened:function(){
                self.getOrders(self.active, self.title)
            }})
          }
        })
      },
      onConfirm(value) {
        this.info.expressage_name = value;
        this.showPicker = false;
      },
      addEdit(account) {
        this.info.id = account
        this.dialogTitle = '订单发货'
          this.show = true
      },
      beforeClose : function (action, done) { // 点击事件 - 备注按钮提示框
        if (action === 'confirm') { // 确认
          if(this.info.expressage_name == ''){
            this.$toast('请选择物流公司')
            done(false);
            return
          }
          if(this.info.expressage_no == ''){
            this.$toast('请输入物流单号')
            done(false);
            return
          }
          this.$api.post('manage/expressage', this.info, r=>{
            if(r.success === 1){
              this.$toast('发货成功')
              window.location.reload()
            }
          })
          done();
        } else if (action === 'cancel') { // 取消
          this.info.id = 0
          this.info.expressage_name = ''
          this.info.expressage_no = ''
          this.getOrders()
          done();
        }
      },
    }
  }
</script>

<style scoped>
  .orders-li{
    overflow: hidden;
    background: #ffffff;
    border-radius: 8px;
    margin: 10px;
    padding:15px;
  }
  .orders-li .o-li-title{
    font-size: 14px;
    overflow: hidden;
    margin-bottom: 10px;
  }
  .orders-li .o-li-title .o-li-title-l{
    float: left;
    font-weight: bold;
  }
  .orders-li .o-li-title .o-li-title-r{
    float: right;
    color: #ED6A0C;
  }
  .orders-li .o-main{
    overflow: hidden;
  }
  .orders-li .o-main .img{
    float: left;
    width: 35%;
  }
  .orders-li .o-main .img img{
    width: 100%;
    height: 80px;
  }
  .orders-li .o-main .info{
    float: right;
    width: 60%;
    margin-left: 5%;
  }
  .orders-li .o-main .info h3{
    margin: 0;
    font-size: 14px;
    font-weight: normal;
    height: 40px;
  }
  .orders-li .o-main .info .price{
    font-size: 14px;
    overflow: hidden;
  }
  .orders-li .o-main .info .price .sp2{
    color:#646566;
  }
  .orders-li .o-main .info .pay-price{
    font-size: 14px;
    margin-top: 5px;
  }
  .orders-li .o-main .info .pay-price .p-sp-2{
    float: right;
  }
  .orders-li .o-bottom{
    overflow: hidden;
    margin-top: 10px;
  }
  .orders-li .o-bottom .time{
    font-size: 12px;
    color:#6D6D6D;
  }
  .orders-li .o-bottom .o-wl{
    float: right;
    font-size: 14px;
    border:1px solid #D3D3D3;
    border-radius: 15px;
    padding: 5px 15px;
    color:#6D6D6D;
    margin-left: 12px;
  }
  .orders-li .o-bottom p{
    margin:0;
    font-size: 13px;
  }
  .delivery-title{
    font-size: 14px;
    color:#ED6A0C;
    float: left;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/manage/orders.vue